import { render, staticRenderFns } from "./task-table.vue?vue&type=template&id=649990f8&scoped=true&"
import script from "./task-table.vue?vue&type=script&lang=ts&"
export * from "./task-table.vue?vue&type=script&lang=ts&"
import style0 from "./task-table.vue?vue&type=style&index=0&id=649990f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649990f8",
  null
  
)

export default component.exports